import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-domain-selection',
  templateUrl: './domain-selection.component.html',
  styleUrls: ['./domain-selection.component.scss']
})
export class DomainSelectionComponent implements OnChanges {
  @Output() emitSelectedValues = new EventEmitter<any>();
  @Input() dropdownData: any[];
  selectedDomain = null;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.setInitialValue();
  }

  changeChevronUp(): void {
    document.getElementsByClassName('ng-arrow-wrapper').item(0)!.classList.add('ng-select-open');
  }

  changeChevronDown(): void {
    document.getElementsByClassName('ng-arrow-wrapper').item(0)!.classList.remove('ng-select-open');
  }

  setInitialValue(): void {
    if (this.dropdownData[0]?.value && this.selectedDomain !== this.dropdownData[0].value) {
      this.selectedDomain = this.dropdownData[0].value;
    }
  }

  getSelectedDomain($event): void {
    this.selectedDomain = $event.value;
    this.emitSelectedValues.emit({ domain: this.selectedDomain });
  }
}
